/**
 * Number formatting shared by every screen that draws one.
 *
 * Here rather than beside the first caller, per the parity review's S-6: search
 * volumes are drawn on the wizard's keyword chips and on `/seo/keywords`, and a
 * second `Intl.NumberFormat` built in the second place is how "2.4k" and "2.4K"
 * end up on adjacent screens.
 */

/**
 * A search volume as the design writes it: "2.4k", "880", "12k" (ONB-16).
 *
 * S-D2's chips carry the compact form (`onboarding.html:423`, `:450`) and the
 * app drew the raw integer, so a five-figure volume was ten characters of chip
 * width for a number nobody reads to the digit. Volume on a keyword chip is a
 * comparison — is this term bigger than that one — and the compact form is the
 * one that can be compared at a glance across a row of chips.
 *
 * `en-IN` rather than the browser's locale, for the reason `Leads.tsx` gives
 * about grouping: the product's numbers are quoted in one convention throughout,
 * and a tenant in Dubai reading their own dashboard should see the same figures
 * their account manager in Hyderabad does. Lower-cased because the design writes
 * "2.4k", where `Intl` emits "2.4K".
 */
const COMPACT = new Intl.NumberFormat('en-IN', { notation: 'compact', maximumFractionDigits: 1 })

export function compactNumber(value: number): string {
  return COMPACT.format(value).toLowerCase()
}
